<template>
  <MainLayoutV2 section="mission">
    <div id="mission_container">
      <div id="mission">
        <img src="@/assets/imgs/ninja-paintbrushes.svg"/>

        <h1 class="alt">Our Mission</h1>
        
        <p>
          Our mission is to create immersive and emotionally rich
          worlds that captivate and inspire players. We develop
          multi-layered gaming experiences that cater to both casual
          audiences and hardcore gamers alike, allowing each player to
          <span class="alt">be the hero of a rewarding journey of exploration and
          discovery.</span>
        </p>
      </div>
    </div>
  </MainLayoutV2>
</template>

<script>
import MainLayoutV2 from '@/components/V2/layout/MainLayoutV2'

export default {
  name: 'MissionV2',
  components: {
    MainLayoutV2
  }
}
</script>

<style scoped lang="scss">
@import '@/scss/custom.scss';

#mission_container{
  padding: 100px 0 75px 0;
}

#mission{
  width: 50%;
  min-height: 550px;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: $white;
  font-family: Alliance No2;
}

#main_layout_v2.md #mission,
#main_layout_v2.sm #mission,
#main_layout_v2.xs #mission{
  width: 70%;
}

#mission img{
  width: 250px;
}

#mission h1{
  font-family: Bricolage Grotesque ExtraBold;
  margin-bottom: 25px;
}

#mission .alt{
  color: $sunset-coral;
}
</style>
